/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ListingsInputs */

const en_nav_listings = /** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings`)
};

const id_nav_listings = /** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing`)
};

/** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */
const es_nav_listings = en_nav_listings;

/** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */
const fr_nav_listings = en_nav_listings;

/** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */
const de_nav_listings = en_nav_listings;

/** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */
const ja_nav_listings = en_nav_listings;

/** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */
const zh_nav_listings = en_nav_listings;

/** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */
const ar_nav_listings = en_nav_listings;

/** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */
const it_nav_listings = en_nav_listings;

/** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */
const ru_nav_listings = en_nav_listings;

/** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */
const pt_nav_listings = en_nav_listings;

/** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */
const ko_nav_listings = en_nav_listings;

/**
* | output |
* | --- |
* | "Listings" |
*
* @param {Nav_ListingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_listings = /** @type {((inputs?: Nav_ListingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ListingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_listings(inputs)
	if (locale === "es") return es_nav_listings(inputs)
	if (locale === "fr") return fr_nav_listings(inputs)
	if (locale === "de") return de_nav_listings(inputs)
	if (locale === "ja") return ja_nav_listings(inputs)
	if (locale === "zh") return zh_nav_listings(inputs)
	if (locale === "ar") return ar_nav_listings(inputs)
	if (locale === "id") return id_nav_listings(inputs)
	if (locale === "it") return it_nav_listings(inputs)
	if (locale === "ru") return ru_nav_listings(inputs)
	if (locale === "pt") return pt_nav_listings(inputs)
	return ko_nav_listings(inputs)
});